module.exports = __webpack_public_path__ + "img/w3_circle_bars_white.2de46224.png";